import { DollarCircleIcon } from '@synoptic/ui-kit/icons/react/dollar-circle.js';
import clsx from 'clsx';
import {
  moneyBadgeContainer,
  moneyBadgeIcon,
} from '@/components/tournaments/money-badge.css.ts';

export const MoneyBadge = ({
  text,
  className,
}: {
  text: string;
  className?: string;
}) => {
  return (
    <div className={clsx(moneyBadgeContainer, className)}>
      <div className={moneyBadgeIcon}>
        <DollarCircleIcon width={16} height={16} />
      </div>
      <span>{text}</span>
    </div>
  );
};
